
<template>
    
        <c-popup v-if="show" class="clue-pop" :show="show" :shadow-close="shadowClose" @close="close" catchtouchmove="true"><clue-form :info="info" :form-info="formInfo" :query-info="queryInfo" :com-type="comType" :optype="optype" part-from="pop" clue-title="咨询问题" select-type="all" @close="close" @formChange="formChange" @successSubmit="successSubmit"></clue-form></c-popup>
    
</template>

<script>
/* globals getApp, Page, swan, getCurrentPages, globalData */
import Popup from "../../../components/common/newPopup.vue";
import clueForm from "./clueForm.vue";
import log from '../../../static/utils/ubcLog';
export default {
  components: {
    'c-popup': Popup,
    'clue-form': clueForm
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    info: {
      type: Array,
      default: () => []
    },
    formInfo: {
      type: Object,
      default: () => {}
    },
    // url信息
    queryInfo: {
      type: Object,
      default: () => {}
    },
    // 组件类型
    comType: {
      type: String,
      default: ''
    },
    optype: {
      type: String,
      default: ''
    },
    shadowClose: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        log.send({
          area: 'biaodan-retention',
          serverId: 17260,
          action: 'show',
          optype: this.optype
        });
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit('close');
    },
    /**
     * 表单切换
     */

    formChange(info) {
      this.$emit('formChange', info);
    },
    /**
     * 表单提交成功
     */
    successSubmit() {
      this.$emit('successSubmit');
    }
  }
};
</script>

<style scoped>

</style>
